"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Body1", {
    enumerable: true,
    get: function() {
        return Body1;
    }
});
const _createPreset = require("../createPreset");
const _useBody1Stylesstyles = require("./useBody1Styles.styles");
const Body1 = (0, _createPreset.createPreset)({
    useStyles: _useBody1Stylesstyles.useBody1Styles,
    className: _useBody1Stylesstyles.body1ClassNames.root,
    displayName: 'Body1'
});
